import { useCallback } from 'react'

import { useSearchRequest } from '@wwt/store/searchRequest'

import { generateTitle } from '../utils'
import { useCreateSetMutation } from './useCreateSetMutation'

export const useCreateSet = () => {
	const createSet = useCreateSetMutation()
	const checkInDate = useSearchRequest(
		state => state.mainRequestState?.stay.defaultStayPeriod?.checkIn
	)

	const handleCreateSet = useCallback(
		(title?: string) => {
			return createSet.mutateAsync(
				title ??
					generateTitle({
						// FIXME: Add city and country from reverse lookup
						city: undefined,
						country: undefined,
						date: checkInDate
					})
			)
		},
		[checkInDate, createSet]
	)

	return handleCreateSet
}
